var map = {
	"./abbottabad-2022/01.jpg": 8002,
	"./abbottabad-2022/02.jpg": 7261,
	"./abbottabad-2022/03.jpg": 6336,
	"./bara-gali-2022/01.jpg": 664,
	"./bara-gali-2022/02.jpg": 647,
	"./bara-gali-2022/03.jpg": 2906,
	"./beaconhouse-2024/01.jpg": 5222,
	"./beaconhouse-2024/02.jpg": 2993,
	"./beaconhouse-2024/03.jpg": 9268,
	"./beaconhouse-2025/01.jpg": 8265,
	"./beaconhouse-2025/02.jpg": 9598,
	"./beaconhouse-2025/03.jpg": 5435,
	"./chakwal-safar-e-nau-2025/01.jpg": 9667,
	"./chakwal-safar-e-nau-2025/02.jpg": 9956,
	"./chakwal-safar-e-nau-2025/03.jpg": 1761,
	"./chakwal-safar-e-nau-2025/04.jpg": 6530,
	"./chakwal-safar-e-nau-2025/05.jpg": 8239,
	"./chakwal-safar-e-nau-2025/06.jpg": 864,
	"./chakwal-safar-e-nau-2025/07.jpg": 5757,
	"./fazaia-seminar-2024/01.jpg": 1122,
	"./fazaia-seminar-2024/02.jpg": 77,
	"./fazaia-seminar-2024/03.jpg": 4512,
	"./hassanabdal-2023/01.jpg": 7525,
	"./hassanabdal-2023/02.jpg": 6538,
	"./hassanabdal-2023/03.jpg": 9191,
	"./kalam-2022/01.jpg": 4918,
	"./kalam-2022/02.jpg": 769,
	"./kalam-2022/03.jpg": 8964,
	"./lahore-science-mela-2023/01.jpg": 1629,
	"./lahore-science-mela-2023/02.jpg": 2674,
	"./lahore-science-mela-2023/03.jpg": 2703,
	"./lincoln-corners-2024/01.jpg": 2986,
	"./lincoln-corners-2024/02.jpg": 7189,
	"./lincoln-corners-2024/03.jpg": 3224,
	"./stemx-nust-2024/01.jpg": 3330,
	"./stemx-nust-2024/02.jpg": 2557,
	"./stemx-nust-2024/03.jpg": 7664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;